import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Loads a full check-in after the user has given their initial reaction
 */
export const loadCheckInAfterGettingCurrentMood = store.effects.create(
  (feature: Feature) =>
    feature.actions.giveCurrentMood
      .observe()
      .pipe(
        rxjs.map(() =>
          feature.actions.loadCheckIn
            .from('loadCheckInAfterGettingCurrentMood')
            .create(),
        ),
      ),
)
